exports.ALL = [
  {
    "Name": "Archer",
    "Daily Wage": "",
    "Monthly Wage": "$125.00",
    "Monthly Live-In Wage": "$93.75",
    "Space": "5'",
    "Share": "20%",
    "Special": "",
    "Wealth": "3",
    "Weapon": "bow|secondary",
    "Armor": "light",
    "Gear": "military|adventure",
  },
  {
    "Name": "Crossbowman",
    "Daily Wage": "",
    "Monthly Wage": "$125.00",
    "Monthly Live-In Wage": "$93.75",
    "Space": "5'",
    "Share": "20%",
    "Special": "",
    "Wealth": "3",
    "Weapon": "crossbow|secondary",
    "Armor": "medium,heavy",
    "Gear": "military|adventure",
  },
  {
    "Name": "Horseman",
    "Daily Wage": "",
    "Monthly Wage": "$200.00",
    "Monthly Live-In Wage": "$150.00",
    "Space": "5'",
    "Share": "20%",
    "Special": "",
    "Wealth": "3",
    "Weapon": "one-hander|secondary",
    "Armor": "light,medium",
    "Gear": "mount|mount-light",
  },
  {
    "Name": "Cavalier",
    "Daily Wage": "",
    "Monthly Wage": "$200.00",
    "Monthly Live-In Wage": "$150.00",
    "Space": "5'",
    "Share": "20%",
    "Special": "",
    "Wealth": "3",
    "Weapon": "one-hander,two-hander|secondary",
    "Armor": "medium,heavy",
    "Gear": "mount|mount-heavy",
  },
  {
    "Name": "Man-At-Arms",
    "Daily Wage": "",
    "Monthly Wage": "$100.00",
    "Monthly Live-In Wage": "$75.00",
    "Space": "5'",
    "Share": "20%",
    "Special": "",
    "Wealth": "3",
    "Weapon": "one-hander,one-hander+shield,two-hander|secondary",
    "Armor": "light,medium,heavy",
    "Gear": "military|adventure",
  },
  {
    "Name": "Axeman",
    "Daily Wage": "",
    "Monthly Wage": "$100.00",
    "Monthly Live-In Wage": "$75.00",
    "Space": "5'",
    "Share": "20%",
    "Special": "",
    "Wealth": "3",
    "Weapon": "axe,axe+shield,great-axe|secondary",
    "Armor": "medium,heavy",
    "Gear": "military|adventure",
  },
  {
    "Name": "Spearman",
    "Daily Wage": "",
    "Monthly Wage": "$150.00",
    "Monthly Live-In Wage": "$112.50",
    "Space": "5'",
    "Share": "20%",
    "Special": "",
    "Wealth": "3",
    "Weapon": "spear|secondary",
    "Armor": "medium,heavy",
    "Gear": "military|adventure",
  },
  {
    "Name": "Pikeman",
    "Daily Wage": "",
    "Monthly Wage": "$150.00",
    "Monthly Live-In Wage": "$112.50",
    "Space": "5'",
    "Share": "20%",
    "Special": "",
    "Wealth": "3",
    "Weapon": "polearm|secondary",
    "Armor": "medium,heavy",
    "Gear": "military|adventure",
  },
];


// WEBPACK FOOTER //
// ./src/data/mercenaries.js